import { useQuery } from '@tanstack/react-query'

import { getTeams } from 'common/api/teamsApi'
import { contentKeys } from 'features/unifiedFlow/api/queryKeys'

const useFetchTeams = (accountId: string) => {
  const { data: teams, isPending } = useQuery({
    queryKey: contentKeys.teams(accountId),
    queryFn: () => getTeams(accountId),
  })

  return { data: teams?.data, isPending }
}

export default useFetchTeams
